<template>
  <SlideSidebarContainer>
    <template #title>
      <img :src="notification.action.image" width="30" />
      <span class="ml-2">novidade na área</span>
    </template>

    <NotificationPost :notification="notification" />
  </SlideSidebarContainer>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SlideSidebarContainer from '@/components/layout/sidebars/SlideSidebarContainer'
  import NotificationPost from '@/components/notification/NotificationPost'

  export default {
    components: {
      SlideSidebarContainer,
      NotificationPost,
    },

    props: {
      notification: { type: Object, required: true }
    },

    computed: {
      ...mapGetters('user', ['user'])
    }
  }
</script>